import { render, staticRenderFns } from "./mainUser.vue?vue&type=template&id=7bdb1eae&scoped=true&"
import script from "./mainUser.vue?vue&type=script&lang=js&"
export * from "./mainUser.vue?vue&type=script&lang=js&"
import style0 from "./mainUser.vue?vue&type=style&index=0&id=7bdb1eae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdb1eae",
  null
  
)

export default component.exports